import { ShareNetwork } from "@phosphor-icons/react";
import { useTranslation } from "@/contexts/LanguageContext";

export const GALERIA_SOCIAL_URL = "https://www.galeriasocial.com/";

export default function GaleriaShareButton({ testId = "share-galeria-btn", className = "" }) {
  const { lang } = useTranslation();
  return (
    <a
      href={GALERIA_SOCIAL_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium px-2.5 py-1 rounded-full border border-[#F5A524]/30 text-[#F5A524] hover:bg-[#F5A524]/10 hover:border-[#F5A524]/60 transition-colors ${className}`}
    >
      <ShareNetwork weight="bold" className="w-3.5 h-3.5" />
      {lang === "es" ? "Compartir en Galería Social" : "Share to Galería Social"}
    </a>
  );
}
